export const MOBILE_JOYSTICK_DEAD_ZONE = 0.28;

export type MobileJoystickDirections = {
  left: boolean;
  right: boolean;
};

/** Pure rules — Kerning mobile-control-rules 패턴 (수평만). */
export function mobileJoystickDirections(
  deltaX: number,
  horizontalRadius: number,
  deadZone: number = MOBILE_JOYSTICK_DEAD_ZONE,
): MobileJoystickDirections {
  const safeX =
    Number.isFinite(horizontalRadius) && horizontalRadius > 0
      ? horizontalRadius
      : Number.POSITIVE_INFINITY;
  const normalizedX = Number.isFinite(deltaX) ? deltaX / safeX : 0;
  return {
    left: normalizedX < -deadZone,
    right: normalizedX > deadZone,
  };
}

export function clampMobileJoystickOffset(
  deltaX: number,
  horizontalRadius: number,
): number {
  if (
    !Number.isFinite(deltaX) ||
    !Number.isFinite(horizontalRadius) ||
    horizontalRadius <= 0
  ) {
    return 0;
  }
  return Math.max(-horizontalRadius, Math.min(horizontalRadius, deltaX));
}
